import { render } from "./MapPosition.vue?vue&type=template&id=480a2e4c&scoped=true"
import script from "./MapPosition.vue?vue&type=script&lang=js"
export * from "./MapPosition.vue?vue&type=script&lang=js"

import "./MapPosition.vue?vue&type=style&index=0&id=480a2e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480a2e4c"]])

export default __exports__